











































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'

export enum OzTextButtonColorScheme {
  Primary = 'Primary',
  Secondary = 'Secondary',
  SecondaryMuted = 'SecondaryMuted',
  Danger = 'Danger',
  Active = 'Active',
}

/**
 * Text-only, box-less "button". Style this as you would normal text.
 */
@Component({ components: { OzBaseButton } })
export default class OzTextButton extends Vue {
  ColorScheme = OzTextButtonColorScheme

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * Determines the color of the link. Use `Active` when you want to force the selection color.
   */
  @Prop({ default: OzTextButtonColorScheme.Primary }) colorScheme!: OzTextButtonColorScheme

  /**
   * Text. Generates `title`, which is useful when text is truncated.
   */
  @Prop({ default: undefined }) text?: string
}
